<template>
    <v-container fluid>
        <customer-form
            :customer="this.customer"
            @saved="saved"
            v-if="this.customer"
            class="mb-5 pa-2"
        ></customer-form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import Customer from '@/models/Customer'
import Form from './Form'

export default {
    props: ['id'],

    data: () => {
        return {
            customer: null,
        }
    },

    components: {
        'customer-form': Form,
    },

    methods: {
        async getCustomer() {
            let item = await this.model.find(this.id)

            this.customer = item
        },

        saved() {
            this.$router.push({ name: 'customer.index' })
        },
    },

    computed: {
        model() {
            return new Customer()
        },
    },

    created() {
        this.getCustomer()
    },
}
</script>

<style></style>
